import { getServerEndpoint } from "../../utils/serverEndpoint";

class LocationPrefixSerice {
  constructor() {
    this.prefixList = [];
  }
  async populatePrefixList() {
    let token = localStorage.getItem("access_token") || null;
    if (token) {
      try {
        let response = await fetch(getServerEndpoint() + "api/applicationlookups/getlist/LocationPrefix", {
          headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: token },
          method: "GET",
        });
        if (response.status >= 200 && response.status < 300) {
          let parsedRes = await response.text();
          this.prefixList = JSON.parse(parsedRes);
          if (!Array.isArray(this.prefixList)) {
            this.prefixList = [];
            console.log("Received Prefix List but the data seems to be invalid!");
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
  }

  getPrefixMp(milepost, locId) {
    let mp = parseFloat(milepost);
    if (isNaN(mp)) return "";
    let item = this.prefixList.find((loc) => loc.code === locId);
    if (item) {
      let range = item.opt2.find((r) => (r.start <= mp && r.end >= mp) || (r.start >= mp && r.end <= mp));
      if (range) return range.prefix + " ";
    }
    return "";
  }
}

export const LocPrefixService = new LocationPrefixSerice();



// WEBPACK FOOTER //
// ./src/components/LocationPrefixEditor/LocationPrefixService.js